import { render, staticRenderFns } from "./MnemonicWordsDialog.vue?vue&type=template&id=1063d86a&scoped=true&"
import script from "./MnemonicWordsDialog.vue?vue&type=script&lang=js&"
export * from "./MnemonicWordsDialog.vue?vue&type=script&lang=js&"
import style0 from "./MnemonicWordsDialog.vue?vue&type=style&index=0&id=1063d86a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1063d86a",
  null
  
)

export default component.exports